import React, { useState, useEffect } from 'react';

interface Props {
  weddingDate: string;
}

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const CountdownTimer: React.FC<Props> = ({ weddingDate }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(weddingDate) - +new Date();
      
      if (difference > 0) {
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, [weddingDate]);

  const formatTime = (value: number) => value.toString().padStart(2, '0');

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  };

  return (
    <section className="countdown-section">
      {/* Background with gradient using existing palette */}
      <div className="countdown-background">
        <div className="countdown-background-overlay"></div>
        {/* Decorative pattern */}
        <div className="countdown-pattern">
          <svg className="pattern-svg" viewBox="0 0 400 800" preserveAspectRatio="xMidYMid slice">
            <defs>
              <pattern id="floralPattern" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
                <g transform="translate(100, 100)">
                  <circle cx="0" cy="0" r="40" fill="none" stroke="rgba(254, 251, 242, 0.1)" strokeWidth="2"/>
                  <circle cx="0" cy="0" r="30" fill="none" stroke="rgba(254, 251, 242, 0.15)" strokeWidth="1.5"/>
                  <circle cx="0" cy="0" r="20" fill="none" stroke="rgba(254, 251, 242, 0.2)" strokeWidth="1"/>
                </g>
                <g transform="translate(50, 50)">
                  <circle cx="0" cy="0" r="20" fill="none" stroke="rgba(254, 251, 242, 0.1)" strokeWidth="1"/>
                  <circle cx="0" cy="0" r="15" fill="none" stroke="rgba(254, 251, 242, 0.15)" strokeWidth="0.8"/>
                </g>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#floralPattern)"/>
          </svg>
        </div>
      </div>

      {/* Header */}
      <div className="countdown-header">
        <h1 className="countdown-subtitle">
          CUENTA REGRESIVA
        </h1>
        <h2 className="countdown-title-script">
          Nuestra Boda
        </h2>
        <p className="countdown-date">
          {formatDate(weddingDate)}
        </p>
      </div>

      {/* Countdown Display */}
      <div className="countdown-display">
        <div className="countdown-card">
          {/* Time Display */}
          <div className="countdown-time">
            {formatTime(timeLeft.days)}:{formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </div>
          
          {/* Labels */}
          <div className="countdown-labels">
            <span className="countdown-label">DÍAS</span>
            <span className="countdown-label">HORAS</span>
            <span className="countdown-label">MINUTOS</span>
            <span className="countdown-label">SEGUNDOS</span>
          </div>
        </div>
      </div>

      {/* Bottom spacing */}
      <div className="countdown-bottom"></div>
    </section>
  );
};

export default CountdownTimer;